import React, { useState, useEffect, useRef } from 'react';

// ─── TEMI DISPONIBILI ─────────────────────────────────────────────────────────
const TEMI = [
  {
    id: 'blu',
    label: 'Blu (default)',
    vars: {
      '--accent': '#1D5FAA', '--accent-light': '#E8F0FA', '--accent-dark': '#134080',
      '--bg': '#F0F4FA', '--surface': '#FFFFFF',
      '--border': 'rgba(29,95,170,0.10)', '--border-strong': 'rgba(29,95,170,0.20)',
      '--text': '#0F1E35', '--text-muted': '#4A5C74', '--text-faint': '#8A9BB5',
      '--shadow-sm': '0 1px 4px rgba(29,95,170,0.08)', '--shadow-md': '0 4px 16px rgba(29,95,170,0.12)',
    }
  },
  {
    id: 'verde',
    label: 'Verde',
    vars: {
      '--accent': '#1A7A4A', '--accent-light': '#E3F5EB', '--accent-dark': '#0F5233',
      '--bg': '#F0F8F3', '--surface': '#FFFFFF',
      '--border': 'rgba(26,122,74,0.10)', '--border-strong': 'rgba(26,122,74,0.22)',
      '--text': '#0D2118', '--text-muted': '#3D6350', '--text-faint': '#7DA88C',
      '--shadow-sm': '0 1px 4px rgba(26,122,74,0.08)', '--shadow-md': '0 4px 16px rgba(26,122,74,0.12)',
    }
  },
  {
    id: 'viola',
    label: 'Viola',
    vars: {
      '--accent': '#6D28D9', '--accent-light': '#EDE9FE', '--accent-dark': '#4C1D95',
      '--bg': '#F5F3FF', '--surface': '#FFFFFF',
      '--border': 'rgba(109,40,217,0.10)', '--border-strong': 'rgba(109,40,217,0.22)',
      '--text': '#1E1235', '--text-muted': '#4C3D72', '--text-faint': '#9B8DC0',
      '--shadow-sm': '0 1px 4px rgba(109,40,217,0.08)', '--shadow-md': '0 4px 16px rgba(109,40,217,0.12)',
    }
  },
  {
    id: 'antracite',
    label: 'Antracite',
    vars: {
      '--accent': '#374151', '--accent-light': '#F3F4F6', '--accent-dark': '#111827',
      '--bg': '#F1F3F5', '--surface': '#FFFFFF',
      '--border': 'rgba(55,65,81,0.12)', '--border-strong': 'rgba(55,65,81,0.25)',
      '--text': '#111827', '--text-muted': '#4B5563', '--text-faint': '#9CA3AF',
      '--shadow-sm': '0 1px 4px rgba(0,0,0,0.07)', '--shadow-md': '0 4px 16px rgba(0,0,0,0.10)',
    }
  },
  {
    id: 'petrolio',
    label: 'Petrolio',
    vars: {
      '--accent': '#0E7490', '--accent-light': '#E0F2F7', '--accent-dark': '#0A5468',
      '--bg': '#EFF6F8', '--surface': '#FFFFFF',
      '--border': 'rgba(14,116,144,0.10)', '--border-strong': 'rgba(14,116,144,0.22)',
      '--text': '#0C2530', '--text-muted': '#3E6372', '--text-faint': '#7FA3B1',
      '--shadow-sm': '0 1px 4px rgba(14,116,144,0.08)', '--shadow-md': '0 4px 16px rgba(14,116,144,0.12)',
    }
  },
  {
    id: 'bordeaux',
    label: 'Bordeaux',
    vars: {
      '--accent': '#9F1239', '--accent-light': '#FCE7EC', '--accent-dark': '#6F0D28',
      '--bg': '#FBF3F5', '--surface': '#FFFFFF',
      '--border': 'rgba(159,18,57,0.10)', '--border-strong': 'rgba(159,18,57,0.22)',
      '--text': '#2A0E16', '--text-muted': '#6B3B48', '--text-faint': '#B08A95',
      '--shadow-sm': '0 1px 4px rgba(159,18,57,0.08)', '--shadow-md': '0 4px 16px rgba(159,18,57,0.12)',
    }
  },
  {
    id: 'scuro',
    label: 'Scuro',
    vars: {
      '--accent': '#60A5FA', '--accent-light': '#1E3A5F', '--accent-dark': '#93C5FD',
      '--bg': '#0F172A', '--surface': '#1E293B',
      '--border': 'rgba(96,165,250,0.15)', '--border-strong': 'rgba(96,165,250,0.30)',
      '--text': '#F1F5F9', '--text-muted': '#94A3B8', '--text-faint': '#64748B',
      '--shadow-sm': '0 1px 4px rgba(0,0,0,0.3)', '--shadow-md': '0 4px 16px rgba(0,0,0,0.4)',
    }
  },
];

const FONTS = [
  { id: 'dm',      label: 'DM Sans (default)', stack: "'DM Sans', sans-serif" },
  { id: 'inter',   label: 'Inter',              stack: "'Inter', sans-serif" },
  { id: 'roboto',  label: 'Roboto',             stack: "'Roboto', sans-serif" },
  { id: 'system',  label: 'Sistema',            stack: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" },
  { id: 'georgia', label: 'Georgia (serif)',     stack: "Georgia, 'Times New Roman', serif" },
];

const DIMENSIONI = [
  { id: 'xs',  label: 'Molto piccolo', size: '12px' },
  { id: 'sm',  label: 'Piccolo',       size: '13px' },
  { id: 'md',  label: 'Normale',       size: '14px' },
  { id: 'lg',  label: 'Grande',        size: '15px' },
  { id: 'xl',  label: 'Molto grande',  size: '16px' },
];

const SIDEBAR_WIDTHS = [
  { id: 'compatta', label: 'Compatta', w: '200px' },
  { id: 'normale',  label: 'Normale',  w: '230px' },
  { id: 'ampia',    label: 'Ampia',    w: '260px' },
];

const SIDEBAR_COLORS = [
  { id: 'bianco',    label: 'Bianco (default)', bg: '#FFFFFF', text: '#4A5C74' },
  { id: 'blu-scuro', label: 'Blu scuro',        bg: '#1D3557', text: '#A8C4E0' },
  { id: 'grigio',    label: 'Grigio antracite', bg: '#2D3748', text: '#A0AEC0' },
  { id: 'verde-scuro',label: 'Verde scuro',     bg: '#1A3A2A', text: '#7DB89A' },
  { id: 'viola-scuro',label: 'Viola scuro',     bg: '#2D1B69', text: '#B794F4' },
  { id: 'nero',      label: 'Nero',             bg: '#111827', text: '#9CA3AF' },
];

const BTN_RADIUSES = [
  { id: 'square',   label: 'Squadrato',  r: '2px'  },
  { id: 'sm',       label: 'Leggermente arrotondato', r: '4px' },
  { id: 'default',  label: 'Normale',    r: '6px'  },
  { id: 'lg',       label: 'Arrotondato', r: '10px' },
  { id: 'pill',     label: 'Pillola',    r: '20px' },
];

const FONT_TITOLI = [
  { id: 'serif', label: 'Elegante (Playfair)', stack: "'Playfair Display', serif" },
  { id: 'testo', label: 'Come il testo',       stack: 'inherit' },
];

// intensità delle linee che separano le righe delle tabelle (percentuale del colore principale)
const LINEE_RIGHE = [
  { id: 'leggere',  label: 'Leggere',     riga: 12, testa: 30 },
  { id: 'normali',  label: 'Normali',     riga: 22, testa: 45 },
  { id: 'marcate',  label: 'Marcate',     riga: 32, testa: 55 },
  { id: 'forti',    label: 'Molto marcate', riga: 48, testa: 70 },
];

const DENSITA_RIGHE = [
  { id: 'compatta', label: 'Compatte',  pad: '6px'  },
  { id: 'normale',  label: 'Normali',   pad: '11px' },
  { id: 'ampia',    label: 'Ariose',    pad: '16px' },
];

const ANGOLI = [
  { id: 'netti',    label: 'Netti',     r: '3px',  rs: '2px' },
  { id: 'medi',     label: 'Medi',      r: '10px', rs: '6px' },
  { id: 'morbidi',  label: 'Morbidi',   r: '16px', rs: '10px' },
];

const DEFAULTS = {
  tema: 'blu', font: 'dm', dimensione: 'md', sidebar: 'normale', sidebar_color: 'bianco', btn_radius: 'default',
  font_titoli: 'serif', linee_righe: 'marcate', densita_righe: 'normale', righe_alternate: false, linee_colonne: false,
  angoli: 'medi', colore_custom: '',
};

const SETTINGS_KEY = 'sp_settings';

// ── utilità colore ──────────────────────────────────────────────────────────
const HEX = /^#[0-9a-fA-F]{6}$/;
const hexToRgb = h => [1, 3, 5].map(i => parseInt(h.slice(i, i + 2), 16));
const rgbToHex = c => '#' + c.map(v => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, '0')).join('');
// mescola a con b (t = quota di b, da 0 a 1)
const mescola = (a, b, t) => { const A = hexToRgb(a), B = hexToRgb(b); return rgbToHex(A.map((v, i) => v * (1 - t) + B[i] * t)); };

export function loadSettings() {
  try {
    return JSON.parse(localStorage.getItem(SETTINGS_KEY)) || {};
  } catch(e) { return {}; }
}

export function applySettings(impostazioni) {
  const settings = { ...DEFAULTS, ...(impostazioni || {}) };
  const tema   = TEMI.find(t => t.id === settings.tema) || TEMI[0];
  const font   = FONTS.find(f => f.id === settings.font) || FONTS[0];
  const dim    = DIMENSIONI.find(d => d.id === settings.dimensione) || DIMENSIONI[2];
  const sw     = SIDEBAR_WIDTHS.find(s => s.id === settings.sidebar) || SIDEBAR_WIDTHS[1];
  const sc     = SIDEBAR_COLORS.find(s => s.id === settings.sidebar_color) || SIDEBAR_COLORS[0];
  const br     = BTN_RADIUSES.find(b => b.id === settings.btn_radius) || BTN_RADIUSES[2];
  const ft     = FONT_TITOLI.find(f => f.id === settings.font_titoli) || FONT_TITOLI[0];
  const lr     = LINEE_RIGHE.find(l => l.id === settings.linee_righe) || LINEE_RIGHE[2];
  const dr     = DENSITA_RIGHE.find(d => d.id === settings.densita_righe) || DENSITA_RIGHE[1];
  const an     = ANGOLI.find(a => a.id === settings.angoli) || ANGOLI[1];

  const root = document.documentElement;
  const vars = { ...tema.vars };

  // colore principale personalizzato: ricalcolo le sfumature collegate
  if (HEX.test(settings.colore_custom || '')) {
    const a = settings.colore_custom;
    const scuro = tema.id === 'scuro';
    const [r, g, b] = hexToRgb(a);
    vars['--accent']       = a;
    vars['--accent-light'] = scuro ? mescola(a, '#1E293B', 0.75) : mescola(a, '#FFFFFF', 0.88);
    vars['--accent-dark']  = scuro ? mescola(a, '#FFFFFF', 0.35) : mescola(a, '#000000', 0.35);
    vars['--border']        = `rgba(${r},${g},${b},${scuro ? 0.15 : 0.10})`;
    vars['--border-strong'] = `rgba(${r},${g},${b},${scuro ? 0.30 : 0.22})`;
    vars['--shadow-sm']     = `0 1px 4px rgba(${r},${g},${b},0.08)`;
    vars['--shadow-md']     = `0 4px 16px rgba(${r},${g},${b},0.12)`;
  }
  Object.entries(vars).forEach(([k,v]) => root.style.setProperty(k, v));

  // Sidebar mini persiste dal localStorage direttamente
  const isMini = localStorage.getItem('sp_sidebar_mini') === '1';
  root.style.setProperty('--sidebar-w', isMini ? '60px' : sw.w);
  root.style.setProperty('--sidebar-bg', sc.bg);
  root.style.setProperty('--sidebar-text', sc.text);
  root.style.setProperty('--sidebar-active-bg', sc.bg === '#FFFFFF' ? 'var(--accent-light)' : 'rgba(255,255,255,0.1)');
  root.style.setProperty('--btn-radius', br.r);

  // tabelle e righe
  root.style.setProperty('--row-line',      `color-mix(in srgb, var(--accent) ${lr.riga}%, transparent)`);
  root.style.setProperty('--row-line-head', `color-mix(in srgb, var(--accent) ${lr.testa}%, transparent)`);
  root.style.setProperty('--col-line',      settings.linee_colonne ? `color-mix(in srgb, var(--accent) ${Math.round(lr.riga * 0.7)}%, transparent)` : 'transparent');
  root.style.setProperty('--row-pad',       dr.pad);
  root.style.setProperty('--row-hover',     'color-mix(in srgb, var(--accent) 8%, transparent)');
  root.style.setProperty('--row-zebra',     settings.righe_alternate ? 'color-mix(in srgb, var(--accent) 5%, transparent)' : 'transparent');

  // angoli e titoli
  root.style.setProperty('--radius',    an.r);
  root.style.setProperty('--radius-sm', an.rs);
  root.style.setProperty('--font-title', ft.stack);

  document.body.style.fontFamily = font.stack;
  document.body.style.fontSize   = dim.size;
}

export default function Impostazioni({ addToast }) {
  const [settings, setSettings] = useState(() => ({ ...DEFAULTS, ...loadSettings() }));
  const fileRef = useRef();

  const set = (k, v) => setSettings(p => ({ ...p, [k]: v }));

  // Preview in tempo reale
  useEffect(() => { applySettings(settings); }, [settings]);

  const salva = () => {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
    addToast('Impostazioni salvate', 'success');
  };

  const reset = () => {
    const def = { ...DEFAULTS };
    setSettings(def);
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(def));
    addToast('Impostazioni ripristinate', 'success');
  };

  const temaCorrente = TEMI.find(t => t.id === settings.tema) || TEMI[0];

  // esporta/importa: per portare lo stesso aspetto su un altro computer
  const esporta = () => {
    const blob = new Blob([JSON.stringify(settings, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = 'impostazioni-gestionale-sp.json'; a.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };
  const importa = async (file) => {
    if (!file) return;
    try {
      const j = JSON.parse(await file.text());
      if (!j || typeof j !== 'object' || Array.isArray(j)) throw new Error('formato non valido');
      const pulite = {};
      Object.keys(DEFAULTS).forEach(k => { if (j[k] !== undefined && typeof j[k] === typeof DEFAULTS[k]) pulite[k] = j[k]; });
      setSettings({ ...DEFAULTS, ...pulite });
      addToast('Impostazioni importate: controlla e premi "Salva"', 'success');
    } catch (e) { addToast('File non valido: ' + e.message, 'error'); }
    if (fileRef.current) fileRef.current.value = '';
  };

  const scheda = (attivo) => ({
    flex:1, padding:'10px 12px', borderRadius:'var(--radius-sm)', cursor:'pointer',
    border:`2px solid ${attivo ? 'var(--accent)' : 'var(--border)'}`,
    background: attivo ? 'var(--accent-light)' : 'var(--surface)',
    color: attivo ? 'var(--accent)' : 'var(--text)',
    fontWeight: attivo ? 600 : 400,
    fontSize:13, textAlign:'center', transition:'all 0.15s',
  });

  return (
    <div className="page-content">
      <div className="page-header">
        <div>
          <div className="page-title">⚙ Impostazioni</div>
          <div className="page-subtitle">Personalizza aspetto e visualizzazione</div>
        </div>
        <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
          <input ref={fileRef} type="file" accept=".json,application/json" style={{ display:'none' }}
            onChange={e => importa(e.target.files[0])} />
          <button className="btn" onClick={() => fileRef.current && fileRef.current.click()} title="Carica un file di impostazioni salvato">⬆ Importa</button>
          <button className="btn" onClick={esporta} title="Salva le impostazioni in un file, per usarle su un altro computer">⬇ Esporta</button>
          <button className="btn" onClick={reset}>↺ Ripristina default</button>
          <button className="btn btn-primary" onClick={salva}>💾 Salva impostazioni</button>
        </div>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:20 }}>

        <div style={{ display:'flex', flexDirection:'column', gap:20 }}>
        {/* ── Tema colore ────────────────────────────────────────────────── */}
        <div className="card">
          <div className="card-header"><span className="card-title">🎨 Tema colore</span></div>
          <div className="card-body" style={{ display:'flex', flexDirection:'column', gap:10 }}>
            {TEMI.map(t => (
              <label key={t.id} style={{
                display:'flex', alignItems:'center', gap:12,
                padding:'10px 14px', borderRadius:'var(--radius-sm)', cursor:'pointer',
                border:`2px solid ${settings.tema===t.id ? 'var(--accent)' : 'var(--border)'}`,
                background: settings.tema===t.id ? 'var(--accent-light)' : 'var(--surface)',
                transition:'all 0.15s',
              }}>
                <input type="radio" name="tema" value={t.id} checked={settings.tema===t.id}
                  onChange={() => set('tema', t.id)}
                  style={{ accentColor: t.vars['--accent'], cursor:'pointer' }} />
                {/* Pallino colore */}
                <div style={{ display:'flex', gap:4 }}>
                  {['--accent','--bg','--surface'].map(v => (
                    <div key={v} style={{
                      width:16, height:16, borderRadius:'50%',
                      background: t.vars[v],
                      border:'1px solid rgba(0,0,0,0.1)',
                    }} />
                  ))}
                </div>
                <span style={{ fontSize:13, fontWeight: settings.tema===t.id ? 600 : 400 }}>
                  {t.label}
                </span>
                {settings.tema===t.id && (
                  <span style={{ marginLeft:'auto', color:'var(--accent)', fontSize:16 }}>✓</span>
                )}
              </label>
            ))}
          </div>
        </div>

          {/* ── Righe delle tabelle ──────────────────────────────────────── */}
          <div className="card">
            <div className="card-header"><span className="card-title">☰ Righe delle tabelle</span></div>
            <div className="card-body" style={{ display:'flex', flexDirection:'column', gap:14 }}>
              <div>
                <div className="form-label" style={{ marginBottom:6 }}>Linee di separazione</div>
                <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                  {LINEE_RIGHE.map(l => (
                    <button key={l.id} onClick={() => set('linee_righe', l.id)} style={scheda(settings.linee_righe===l.id)}>{l.label}</button>
                  ))}
                </div>
              </div>
              <div>
                <div className="form-label" style={{ marginBottom:6 }}>Altezza delle righe</div>
                <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                  {DENSITA_RIGHE.map(d => (
                    <button key={d.id} onClick={() => set('densita_righe', d.id)} style={scheda(settings.densita_righe===d.id)}>{d.label}</button>
                  ))}
                </div>
              </div>
              <label style={{ display:'flex', alignItems:'center', gap:10, cursor:'pointer', fontSize:13 }}>
                <input type="checkbox" checked={!!settings.righe_alternate}
                  onChange={e => set('righe_alternate', e.target.checked)} style={{ accentColor:'var(--accent)' }} />
                Righe alternate (una sì e una no leggermente colorata)
              </label>
              <label style={{ display:'flex', alignItems:'center', gap:10, cursor:'pointer', fontSize:13 }}>
                <input type="checkbox" checked={!!settings.linee_colonne}
                  onChange={e => set('linee_colonne', e.target.checked)} style={{ accentColor:'var(--accent)' }} />
                Linee verticali tra le colonne
              </label>
            </div>
          </div>

          {/* ── Colore principale ────────────────────────────────────────── */}
          <div className="card">
            <div className="card-header"><span className="card-title">🖌 Colore principale personalizzato</span></div>
            <div className="card-body" style={{ display:'flex', alignItems:'center', gap:12, flexWrap:'wrap' }}>
              <input type="color" value={HEX.test(settings.colore_custom) ? settings.colore_custom : (temaCorrente.vars['--accent'])}
                onChange={e => set('colore_custom', e.target.value)}
                style={{ width:48, height:34, border:'1px solid var(--border-strong)', borderRadius:'var(--radius-sm)', cursor:'pointer', background:'var(--surface)' }} />
              <span style={{ fontSize:13, color:'var(--text-muted)' }}>
                {HEX.test(settings.colore_custom) ? settings.colore_custom.toUpperCase() : 'Usa il colore del tema scelto'}
              </span>
              {HEX.test(settings.colore_custom) && (
                <button className="btn btn-sm" onClick={() => set('colore_custom', '')}>Torna al tema</button>
              )}
            </div>
          </div>
        </div>

        {/* ── Carattere ─────────────────────────────────────────────────── */}
        <div style={{ display:'flex', flexDirection:'column', gap:20 }}>
          <div className="card">
            <div className="card-header"><span className="card-title">🔤 Carattere</span></div>
            <div className="card-body" style={{ display:'flex', flexDirection:'column', gap:8 }}>
              {FONTS.map(f => (
                <label key={f.id} style={{
                  display:'flex', alignItems:'center', gap:12,
                  padding:'8px 12px', borderRadius:'var(--radius-sm)', cursor:'pointer',
                  border:`2px solid ${settings.font===f.id ? 'var(--accent)' : 'var(--border)'}`,
                  background: settings.font===f.id ? 'var(--accent-light)' : 'var(--surface)',
                }}>
                  <input type="radio" name="font" value={f.id} checked={settings.font===f.id}
                    onChange={() => set('font', f.id)}
                    style={{ accentColor:'var(--accent)', cursor:'pointer' }} />
                  <div>
                    <div style={{ fontSize:13, fontWeight:500, fontFamily:f.stack }}>
                      {f.label}
                    </div>
                    <div style={{ fontSize:11, color:'var(--text-faint)', fontFamily:f.stack }}>
                      Clienti · Scadenze · IVA · 1234
                    </div>
                  </div>
                  {settings.font===f.id && (
                    <span style={{ marginLeft:'auto', color:'var(--accent)' }}>✓</span>
                  )}
                </label>
              ))}
            </div>
          </div>

          {/* ── Dimensione testo ─────────────────────────────────────────── */}
          <div className="card">
            <div className="card-header"><span className="card-title">🔍 Dimensione testo</span></div>
            <div className="card-body">
              <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                {DIMENSIONI.map(d => (
                  <button key={d.id} onClick={() => set('dimensione', d.id)} style={{
                    padding:'8px 16px', borderRadius:'var(--radius-sm)', cursor:'pointer',
                    border:`2px solid ${settings.dimensione===d.id ? 'var(--accent)' : 'var(--border)'}`,
                    background: settings.dimensione===d.id ? 'var(--accent-light)' : 'var(--surface)',
                    fontSize: d.size, fontWeight: settings.dimensione===d.id ? 600 : 400,
                    color: settings.dimensione===d.id ? 'var(--accent)' : 'var(--text)',
                    transition:'all 0.15s', flex:'1', textAlign:'center', minWidth:80,
                  }}>
                    {d.label}<br/>
                    <span style={{ fontSize:'10px', opacity:0.6 }}>{d.size}</span>
                  </button>
                ))}
              </div>
              <div style={{ marginTop:12, padding:'10px 14px', background:'var(--bg)',
                borderRadius:'var(--radius-sm)', fontSize:'inherit' }}>
                📋 Anteprima: questo testo mostra la dimensione selezionata.
                Clienti, scadenze, dichiarazioni IVA e avvisi.
              </div>
            </div>
          </div>

          {/* ── Sidebar larghezza ────────────────────────────────────────── */}
          <div className="card">
            <div className="card-header"><span className="card-title">◧ Larghezza sidebar</span></div>
            <div className="card-body">
              <div style={{ display:'flex', gap:8 }}>
                {SIDEBAR_WIDTHS.map(s => (
                  <button key={s.id} onClick={() => set('sidebar', s.id)} style={{
                    flex:1, padding:'10px 12px', borderRadius:'var(--radius-sm)', cursor:'pointer',
                    border:`2px solid ${settings.sidebar===s.id ? 'var(--accent)' : 'var(--border)'}`,
                    background: settings.sidebar===s.id ? 'var(--accent-light)' : 'var(--surface)',
                    color: settings.sidebar===s.id ? 'var(--accent)' : 'var(--text)',
                    fontWeight: settings.sidebar===s.id ? 600 : 400,
                    fontSize:13, textAlign:'center', transition:'all 0.15s',
                  }}>
                    {s.label}<br/>
                    <span style={{ fontSize:10, opacity:0.6 }}>{s.w}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* ── Colore sidebar ───────────────────────────────────────────── */}
          <div className="card">
            <div className="card-header"><span className="card-title">🎨 Colore sidebar</span></div>
            <div className="card-body" style={{ display:'flex', flexDirection:'column', gap:8 }}>
              {SIDEBAR_COLORS.map(sc => (
                <label key={sc.id} style={{
                  display:'flex', alignItems:'center', gap:12,
                  padding:'8px 12px', borderRadius:'var(--radius-sm)', cursor:'pointer',
                  border:`2px solid ${settings.sidebar_color===sc.id ? 'var(--accent)' : 'var(--border)'}`,
                  background: settings.sidebar_color===sc.id ? 'var(--accent-light)' : 'var(--surface)',
                }}>
                  <input type="radio" name="sidebar_color" checked={settings.sidebar_color===sc.id}
                    onChange={() => set('sidebar_color', sc.id)}
                    style={{ accentColor:'var(--accent)', cursor:'pointer' }} />
                  {/* Anteprima colore */}
                  <div style={{
                    width:36, height:22, borderRadius:4, background:sc.bg,
                    border:'1px solid rgba(0,0,0,0.15)',
                    display:'flex', alignItems:'center', justifyContent:'center',
                  }}>
                    <span style={{ fontSize:9, color:sc.text, fontWeight:600 }}>SP</span>
                  </div>
                  <span style={{ fontSize:13, fontWeight: settings.sidebar_color===sc.id ? 600 : 400 }}>
                    {sc.label}
                  </span>
                  {settings.sidebar_color===sc.id && (
                    <span style={{ marginLeft:'auto', color:'var(--accent)' }}>✓</span>
                  )}
                </label>
              ))}
            </div>
          </div>

          {/* ── Forma pulsanti ───────────────────────────────────────────── */}
          <div className="card">
            <div className="card-header"><span className="card-title">🔲 Forma pulsanti</span></div>
            <div className="card-body">
              <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                {BTN_RADIUSES.map(b => (
                  <button key={b.id} onClick={() => set('btn_radius', b.id)} style={{
                    flex:1, minWidth:80, padding:'10px 8px',
                    borderRadius: b.r,
                    cursor:'pointer',
                    border:`2px solid ${settings.btn_radius===b.id ? 'var(--accent)' : 'var(--border)'}`,
                    background: settings.btn_radius===b.id ? 'var(--accent-light)' : 'var(--surface)',
                    color: settings.btn_radius===b.id ? 'var(--accent)' : 'var(--text)',
                    fontWeight: settings.btn_radius===b.id ? 600 : 400,
                    fontSize:12, textAlign:'center', transition:'all 0.15s',
                  }}>
                    {b.label}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* ── Angoli e titoli ──────────────────────────────────────────── */}
          <div className="card">
            <div className="card-header"><span className="card-title">◰ Angoli e titoli</span></div>
            <div className="card-body" style={{ display:'flex', flexDirection:'column', gap:14 }}>
              <div>
                <div className="form-label" style={{ marginBottom:6 }}>Angoli di schede e finestre</div>
                <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                  {ANGOLI.map(a => (
                    <button key={a.id} onClick={() => set('angoli', a.id)}
                      style={{ ...scheda(settings.angoli===a.id), borderRadius:a.r }}>{a.label}</button>
                  ))}
                </div>
              </div>
              <div>
                <div className="form-label" style={{ marginBottom:6 }}>Carattere dei titoli</div>
                <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                  {FONT_TITOLI.map(f => (
                    <button key={f.id} onClick={() => set('font_titoli', f.id)}
                      style={{ ...scheda(settings.font_titoli===f.id), fontFamily:f.stack }}>{f.label}</button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Anteprima completa ─────────────────────────────────────────── */}
      <div className="card" style={{ marginTop:20 }}>
        <div className="card-header"><span className="card-title">👁 Anteprima</span></div>
        <div className="card-body">
          <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:10, marginBottom:12 }}>
            {[['Clienti attivi','133','var(--accent)'],['Scadenze aperte','12','var(--c-red)'],
              ['Attività','8','var(--c-amber)'],['Pratiche IVA','174','var(--c-green)']].map(([l,v,c])=>(
              <div key={l} className="kpi-card">
                <div className="kpi-accent" style={{background:c}}/>
                <div className="kpi-label">{l}</div>
                <div className="kpi-value">{v}</div>
              </div>
            ))}
          </div>
          <div className="table-wrap" style={{ border:'1px solid var(--row-line)', borderRadius:'var(--radius-sm)' }}>
            <table>
              <thead><tr>
                {['Cliente','Scadenza','Stato','Importo'].map(h => <th key={h}>{h}</th>)}
              </tr></thead>
              <tbody>
                {[
                  ['PALUMBO SIMONE','30/04/2025','pill-green','€ 1.200,00'],
                  ['ABINTRAX SRL','16/06/2025','pill-amber','€ 3.450,00'],
                  ['SMARTARREDA SRL','30/11/2025','pill-red','—'],
                  ['ROSSI MARIO','15/12/2025','pill-green','€ 780,00'],
                ].map(([n,d,p,i]) => (
                  <tr key={n}>
                    <td className="fw-500">{n}</td>
                    <td>{d}</td>
                    <td>
                      <span className={`pill ${p}`}>
                        {p==='pill-green'?'Inviata':p==='pill-amber'?'In corso':'Da preparare'}
                      </span>
                    </td>
                    <td style={{ fontFamily:'monospace' }}>{i}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
